export { default } from "./SliderType";
